import { H3, P } from '../ui/typography';
import brandmarkLogo from '@/assets/logos/brandmark.png';

export const Loading = () => {
    return (
        <div className="min-h-screen bg-secondary-dark light:bg-background dark:bg-background flex items-center justify-center relative overflow-hidden w-full">
            <div className="absolute inset-0 bg-gradient-to-br from-secondary-dark via-secondary-light to-secondary-dark light:from-background light:via-background light:to-background dark:from-background dark:via-background dark:to-background opacity-80" />

            <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-secondary-accent/10 rounded-full blur-xl animate-pulse" />
            <div className="absolute bottom-1/4 right-1/4 w-24 h-24 bg-primary/10 rounded-full blur-xl animate-pulse delay-1000" />
            <div className="absolute top-3/4 left-3/4 w-40 h-40 bg-secondary-accent/5 rounded-full blur-2xl animate-pulse delay-500" />

            <div className="relative z-10 text-center px-8">
                <div className="mb-8 animate-fade-in">
                    <img
                        src={brandmarkLogo}
                        alt="Brand Logo"
                        className="h-16 w-auto mx-auto drop-shadow-lg"
                    />
                </div>

                <div className="space-y-2 animate-fade-in delay-500">
                    <H3 variant="type-subheading-small" className="text-white light:text-foreground dark:text-foreground">
                        Loading GoZig
                    </H3>
                    <P variant="type-body-large" className="text-gray-light light:text-foreground dark:text-foreground">
                        Preparing personalized insights for you...
                    </P>
                </div>

                <div className="flex justify-center space-x-2 mt-8 animate-fade-in delay-700">
                    <div className="w-2 h-2 bg-secondary-accent rounded-full animate-bounce" />
                    <div className="w-2 h-2 bg-secondary-accent rounded-full animate-bounce delay-100" />
                    <div className="w-2 h-2 bg-secondary-accent rounded-full animate-bounce delay-200" />
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-secondary-accent to-transparent opacity-60" />
        </div>
    );
};
